import type { PetitionDetailsDataQuery } from './api.graphql';
import type { DiscussionData } from './discussionData';
import type { RecentSignersData } from './recentSignersData';

type Petition = NonNullable<PetitionDetailsDataQuery['petition']> & DiscussionData & RecentSignersData;

export function anonymizeForBots(petition: Petition): Petition {
	return {
		...petition,
		supporterCommentsConnection: {
			...petition.supporterCommentsConnection,
			nodes: petition.supporterCommentsConnection.nodes.map((node) => ({
				...node,
				user: {
					...node.user,
					displayName: node.user.firstName,
					shortDisplayName: node.user.firstName,
					city: null,
					photo: null,
				},
			})),
		},
		recentPublicSignersConnectionV2: {
			...petition.recentPublicSignersConnectionV2,
			edges: petition.recentPublicSignersConnectionV2.edges.map((edge) => ({
				...edge,
				user: {
					...edge.user,
					displayName: edge.user.firstName,
					// Collapsed alongside `displayName`: the carousel renders this field, so a crawler would
					// otherwise see the abbreviated real name.
					displayNameAbbreviated: edge.user.firstName,
					firstName: edge.user.firstName,
					lastName: '',
					photo: null,
				},
			})),
		},
	};
}
